
import { Link } from "react-router-dom";
import { UserNav } from "@/components/UserNav";
import { ThemeToggle } from "@/components/ThemeToggle";

const BrandLogo = () => (
  <Link
    to="/"
    className="text-2xl font-semibold dark:text-white"
    aria-label="IELTSwith.ai homepage"
  >
    <span className="text-orange-500">ielts</span>with.ai
  </Link>
);

export const NavBar = () => {
  return (
    <header className="border-b border-stone-200 dark:border-stone-700 bg-white dark:bg-stone-800">
      <div className="flex h-16 items-center justify-between max-w-6xl container mx-auto px-4">
        <nav
          className="flex items-center gap-4"
          aria-label="Main navigation"
        >
          <BrandLogo />
        </nav>

        <div className="flex items-center gap-2">
          <ThemeToggle />
          <UserNav />
        </div>
      </div>
    </header>
  );
};
